import { AppBar, styled, Toolbar, Button, Box, css } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { LinkProps } from 'react-router-dom';
import { theme } from 'assets/themes/zizzi';

const menuItemColor = theme.palette.white;
const iconHoverColor = theme.palette.neutral.dark;

export const StyledHeader = styled(AppBar)`
  border-radius: 0;
  padding: 0;
  position: fixed;

  ${theme.breakpoints.up('md')} {
    height: 64px;
  }
`;

export const StyledToolbar = styled(Toolbar)`
  padding-left: 5px;
  justify-content: space-between;

  ${theme.breakpoints.up('sm')} {
    padding: 0 10px;
  }
`;

export const ButtonWrapper = styled(Box)`
  display: flex;
  align-items: center;
`;

const buttonStyles = css`
  min-width: 0;

  &:hover svg {
    color: ${iconHoverColor};
  }
`;

const iconStyles = css`
  font-size: 24px;
  display: block;
  color: ${menuItemColor};
  transition: color 0.3s ease-in;
`;

export const BackButton = styled(Button)`
  ${buttonStyles};
`;

export const BackButtonIcon = styled(ArrowBackIcon)`
  ${iconStyles};
`;

export const HomeButton = styled(Button)<LinkProps>`
  ${buttonStyles};
`;

export const HomeButtonIcon = styled(HomeIcon)`
  ${iconStyles};
`;
